const subscriptionTypes = Object.freeze({
  EVERY_TWELVE_MONTHS: 'Every 12 months',
  EVERY_SIX_MONTHS: 'Every 6 months',
  EVERY_THREE_MONTHS: 'Every 3 months'
})

export default subscriptionTypes
